// extracted by mini-css-extract-plugin
export default {"price":"daa-z","onSale":"eaa-z","msrpLabelPrice":"faa-z","msrpLabel":"gaa-z","originalPrice":"haa-z"};